import ApiAuth from './ApiAuth'

export const Brands = {
    brands(context, queryParams) {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`brands${queryParams}`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    uniqueCountries() {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`unique-countries`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    uniqueStatuses() {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`unique-statuses`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    uniqueBrandNames() {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`unique-brand-names`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    uniqueOwners() {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`unique-owners`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    brandDetails(context, id) {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`brand/${id}`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        })
    },
    niceClasses() {
        return new Promise((resolve, reject) => {
            ApiAuth().get('nice_classes').then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    postBrand(context, data) {
        let userToken = localStorage.getItem('user-token');
        return new Promise((resolve, reject) => {
            ApiAuth({headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/form-data',
                    'Accept-Language' : 'en',
                    'Authorization': `Bearer ${userToken}`
                }}).post('/brand', data).then(response => {
                resolve(response.data);
            }).catch((error) => {
                console.log(error);
                reject(error.response);
            });
        });
    },
    editBrand(context, data) {
        let userToken = localStorage.getItem('user-token');
        return new Promise((resolve, reject) => {
            ApiAuth({headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/form-data',
                    'Accept-Language' : 'en',
                    'Authorization': `Bearer ${userToken}`
                }}).post(`/brand/${data.id}`, data.data).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteBrandLogo(context, data) {
        let userToken = localStorage.getItem('user-token');
        return new Promise((resolve, reject) => {
            ApiAuth({headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/form-data',
                    'Accept-Language' : 'en',
                    'Authorization': `Bearer ${userToken}`
                }}).delete(`/brand-logo/${data.id}`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    monitoring(context, id) {
        return new Promise((resolve, reject) => {
            ApiAuth().put(`brand/${id}/change`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteBrand(context, id) {
        return new Promise((resolve, reject) => {
            ApiAuth().delete(`brand/${id}`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    bulk(context, data) {
        return new Promise((resolve, reject) => {
            ApiAuth().post(`bulk`, data).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    searcBrand(context, data) {
        let userToken = localStorage.getItem('user-token');
        return new Promise((resolve, reject) => {
            ApiAuth({headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/form-data',
                    'Accept-Language' : 'en',
                    'Authorization': `Bearer ${userToken}`
                }}).post('/search-brand', data).then(response => {
                resolve(response.data);
            }).catch((error) => {
                console.log(error);
                reject(error.response);
            });
        });
    },
};
